import classNames from 'classnames';
import React from 'react';

export interface IProps extends React.PropsWithChildren {
  className?: string;
}

const ClickFieldInputContainer: React.FC<IProps> = ({ children, className }) => {
  const computedClassName = React.useMemo<string>(() => {
    return classNames('relative flex-grow', className);
  }, [className]);

  return <div className={computedClassName}>{children}</div>;
};

export default ClickFieldInputContainer;
